import { Routes } from '@angular/router';
import { DeleteAccountComponent } from './delete-account-page/components/delete-account/delete-account.component';
import { AutoIndustryComponent } from './landing-page-v1/components/industry/auto-industry/auto-industry.component';
import { HealthcareIndustryComponent } from './landing-page-v1/components/industry/healthcare-industry/healthcare-industry.component';
import { RealEstateIndustryComponent } from './landing-page-v1/components/industry/real-estate-industry/real-estate-industry.component';
import { ShopifyStoresIndustryComponent } from './landing-page-v1/components/industry/shopify-stores-industry/shopify-stores-industry.component';
import { SmartAIIndustryComponent } from './landing-page-v1/components/industry/smart-ai-industry/smart-ai-industry.component';
import { TelecomIndustryComponent } from './landing-page-v1/components/industry/telecom-industry/telecom-industry.component';
import { PricingComponent } from './landing-page-v1/components/pricing/pricing.component';
import { LandingPageV2Component } from './landing-page-v2/landing-page-v2.component';
import { PrivacyPolicyComponent } from './privacy-policy-page/privacy-policy/privacy-policy.component';

export const routes: Routes = [
  {
    path: '',
    // component: LandingV1MainComponent,
    component: LandingPageV2Component,
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'user/delete',
    component: DeleteAccountComponent,
  },
  // {
  //   path: 'recharge-plans',
  //   component: RechargePlansComponent,
  // },
  {
    path: 'industry-smart-ai',
    component: SmartAIIndustryComponent,
  },
  {
    path: 'industry-auto',
    component: AutoIndustryComponent,
  },
  { path: 'industry-telecom', component: TelecomIndustryComponent },
  { path: 'industry-real-estate', component: RealEstateIndustryComponent },
  {
    path: 'industry-healthcare',
    component: HealthcareIndustryComponent,
  },
  {
    path: 'industry-shopify-stores',
    component: ShopifyStoresIndustryComponent,
  },
  { path: 'pricing', component: PricingComponent },
];
